import { FC } from 'react';

import { ArticleList, FiltersBlog, Heading } from '@/components';

import { BlogPostDocument, IBlogTags } from '@/types';
import classNames from 'classnames';
import { IBlogProps } from 'app/(Storefront)/(Shop)/(Content)/blog/(list)/page';

const CollectionPosts: FC<ICollectionPosts> = ({
  articlesList,
  filterOptions,
  props,
  hasPagination,
  numberPostPerPage,
  searchTerm,
}) => {
  return (
    <>
      <Heading
        className="blog__collection_title"
        level={2}
        style={{ color: props?.sectionTitleColor || undefined }}
      >
        {props?.postCollection || 'All Posts'}
      </Heading>
      <div
        className={classNames('blog__section', {
          blog__section__grid: Object.keys(filterOptions).length > 0,
        })}
        style={{
          ...(props?.post_title_color && {
            ['--blog-list-heading-color' as string]: props.post_title_color,
          }),
          ...(props?.textColor && {
            ['--blog-list-text-color' as string]: props.textColor,
          }),
        }}
      >
        <FiltersBlog filterOptions={filterOptions} />
        <ArticleList
          articlesList={articlesList}
          hasPagination={hasPagination}
          numberPostPerPage={numberPostPerPage}
          searchTerm={searchTerm}
          variant="collection"
        />
      </div>
    </>
  );
};

interface ICollectionPosts {
  articlesList: BlogPostDocument<string>[];
  filterOptions: IBlogTags;
  props: IBlogProps;
  numberPostPerPage: number;
  hasPagination: boolean;
  searchTerm: string;
}

export { CollectionPosts };
